import { render, staticRenderFns } from "./EncyclopediaLabel.vue?vue&type=template&id=3907ba40&scoped=true"
import script from "./EncyclopediaLabel.vue?vue&type=script&lang=js"
export * from "./EncyclopediaLabel.vue?vue&type=script&lang=js"
import style0 from "./EncyclopediaLabel.vue?vue&type=style&index=0&id=3907ba40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3907ba40",
  null
  
)

export default component.exports